import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { bsc, mainnet } from "@reown/appkit/networks";
import { useAppKitNetwork } from "@reown/appkit/react";
import RoutesFile from "./RoutesFile";
import "./App.css";

const projectId = "28062f722afd7cd7f4684c5850813c7b";

const networks = [bsc,mainnet];

const metadata = {
  name: "KIND REWARD NETWORK",
  description: "KIND REWARD NETWORK - Buy Packages $KIND & earn rewards. Explore powerful staking packages and maximize your crypto earnings.",
  url: "https://kindwealthnetwork.xyz/",
  icons: ["https://kindwealthnetwork.xyz/kindlogo.png"],
};

const config = createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  metadata,
  projectId,
  defaultChain: bsc,
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
});

function App() {
  const [isMobile, setIsMobile] = useState(true);
  
  const { chainId, caipNetwork, switchNetwork } = useAppKitNetwork();

  // ✅ FIXED AUTO-SWITCH (no await error + works)
  useEffect(() => {
    if (!switchNetwork || !chainId) return;

    // ✅ Mainnet validation (stay)
    if (chainId === mainnet.id) {
      console.log("✅ Mainnet validation OK");
      return;
    }

    // ✅ Auto-switch to BSC (caipNetwork object)
    if (chainId !== bsc.id && bsc) {
      console.log(`🔄 Auto-switching to BSC (from ${chainId})`);
      switchNetwork(bsc);  // ✅ Pass chain OBJECT (fixes TS + works)
    }
  }, [chainId, switchNetwork, bsc, mainnet]);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 640);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <>
      <RoutesFile />
      <Toaster
        position={isMobile ? "top-center" : "top-right"}
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#1e1e1e",
            color: "#ffffff",
            borderRadius: "8px",
          },
        }}
      />
    </>
  );
}

export default App;